
import { defineComponent } from 'vue'
import PatientDemographics from './PatientDemographics.vue'
import PatientSearch from '../shared/PatientSearch.vue'
import PatientSummary from '../shared/PatientSummary.vue'

export default defineComponent({
  name: 'PatientRegistration',
  components : {
    PatientDemographics,
    PatientSearch,
    PatientSummary
  },
  data () {
    return {
      patient: null,
      newPatient: false,
      searchPatient: false,
    }
  },
  methods: {
    onSearch() {
      this.searchPatient = true
      this.patient = null
      this.newPatient = false
    },
    onNew() {
      this.newPatient = true
      this.searchPatient = false
      this.patient = null
    },
    selectedPatient(selectedPatient) {
      this.patient = selectedPatient
      this.searchPatient = false
      this.newPatient = false
    }
  },
  mounted () {
    this.patient = null
    this.searchPatient = true
  }
})
